import { getStorageItem } from "../helpers/utils";

export const errorMessageObject = {
  smoker: "",
  alcohol: "",
  sector: "",
  marital_status: "",
  education: "",
  father_name: "",
  occupation_type: "",
  organisation_name: "",
  annual_income: "",
  income_tax_proof: "",
  pan_number: "",
  einsurance_account_number: "",
  einsurance_repository: "",
  einsurance_account_open: "",
};

export const formObject = {
  smoker: "Non Smoker",
  alcohol: "No",
  sector: "Rural",
  marital_status: "Married",
  education: "Graduation",
  father_name: "",
  occupation_type: "Salaried",
  self_employee_type: "Sole Proprietorship",
  organisation_name: "",
  annual_income: "",
  income_tax_proof: "Form 60",
  pan_number: "",
  partnerId: getStorageItem("partnerId"),
  verify_pan_number: false,
  einsurance_account: "No",
  einsurance_account_number: "",
  einsurance_account_open: "Yes",
  einsurance_repository: "CAMS",
  consent: true,
  declaration: true,
};

export const sectionObject = {
  personal: true,
  eia: false,
};

export const occupationObject = {
  code: "",
  label: "Select",
  risk_categorization: "",
};

export const occupationHouseWifeObject = {
  code: "HOWF",
  label: "Housewife",
  risk_categorization: "Low",
};

export const touchFieldObject = {
  smoker: false,
  alcohol: false,
  sector: false,
  marital_status: false,
  education: false,
  father_name: false,
  occupation_type: false,
  organisation_name: false,
  annual_income: false,
  income_tax_proof: false,
  pan_number: false,
  einsurance_account_number: false,
  einsurance_repository: false,
  einsurance_account_open: false,
};

export const options = {
  smoker: [
    { title: "Yes", value: "Smoker" },
    { title: "No", value: "Non Smoker" },
  ],
  alcohol: [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ],
  sector: [
    { title: "Urban", value: "Urban" },
    { title: "Rural", value: "Rural" },
  ],
  maritalStatus: [
    { title: "Single", value: "Single" },
    { title: "Married", value: "Married" },
  ],
  education: [
    { title: "Post Graduation", value: "Post Graduation" },
    { title: "Graduation", value: "Graduation" },
    { title: "Diploma", value: "Diploma" },
    { title: "12th", value: "12th" },
    { title: "10th", value: "10th" },
  ],
  occupationType: [
    { title: "Salaried", value: "Salaried" },
    { title: "Business", value: "Self-Employed" },
    { title: "Housewife", value: "Housewife" },
  ],
  incomeTaxProof: [
    { title: "PAN", value: "PAN" },
    { title: "Form 60", value: "Form 60" },
  ],
  bankAccountType: [
    { title: "Savings", value: "Savings" },
    { title: "Current", value: "Current" },
  ],
  eiaYesNo: [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ],
  eiaRepository: [
    { title: "CAMS", value: "CAMS" },
    { title: "NSDL", value: "NSDL" },
    { title: "CDSL", value: "CDSL" },
    { title: "KARVY", value: "KARVY" },
  ],
  verifiedAccountDetails: [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ],
};
